import { api } from "../App";
import { SET_WEB_LESSONS_LOADING, SET_WEB_LESSONS_CURRENT, SET_WEB_LESSONS_LIST } from "./types";



export const getToken = (lesId, payload) => async (dispatch) => {
  let token
  try {
    const response = await api.post(`/web_lessons/${lesId}/token`, payload);
    token = response.data.token
  } catch (err) {
    console.error("Ошибка при подключении:", err);
  } finally {
    return token
  }
}

export const getList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: true });
    const response = await api.get('/web_lessons')
    dispatch({ type: SET_WEB_LESSONS_LIST, payload: response.data });
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: false });
  }
};

export const getCurrent = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: true });
    const response = await api.get(`/web_lessons/${id}`)
    dispatch({ type: SET_WEB_LESSONS_CURRENT, payload: response.data });
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: false });
  }
};

export const deleteItem = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: true });
    await api.delete(`/web_lessons/${id}`)
    await dispatch(getList())
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: false });
  }
};

export const updateItem = (id, data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: true });
    await api.put(`/web_lessons/${id}`, data)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: false });
  }
}

export const createItem = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: true });
    await api.post('/web_lessons', data)
    await dispatch(getList())
    success = true
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_WEB_LESSONS_LOADING, payload: false });
    return success
  }
}